
function Calculator() {
    return (
        <div className="calculator-container">
            <iframe 
            src="https://stroy-calc.ru/widj?str=raschet-kirpicha&bgcol=fff&tcol=404040&elcol=00b7ff&dis=none" 
            width="90%" 
            height="700px" 
            title="calculator"
            ></iframe>
        </div>


    );
}

export default Calculator;